/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon20Regular = forwardRef('ArrowFigureACircleRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 10a.75.75 0 0 1 .75-.75h5.193L9.934 7.576a.75.75 0 1 1 .96-1.152l2.679 2.232c.84.7.84 1.989 0 2.688l-2.678 2.232a.75.75 0 0 1-.96-1.152l2.008-1.674H6.751A.75.75 0 0 1 6 10Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.001 10A7.999 7.999 0 1 1 18 10 7.999 7.999 0 0 1 2 10Zm8-6.499A6.499 6.499 0 1 0 10 16.5 6.499 6.499 0 0 0 10 3.5Z" })));
});
